export default {"src":"/_next/static/media/mith.0f7f3369.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};